import { gql } from '@apollo/client';
import { DspDeliveryCompletedDetailFilterType } from '../queries/getDspDeliveryCompletedDetailList';

export const GENERATE_DSP_DELIVERY_COMPLETED_DETAIL_DOWNLOAD_REPORT = gql`
    mutation GenerateDspDeliveryCompletedDetailDownloadReport(
        $filter: DspDeliveryCompletedDetailFilterTypeInput!
        $sortBy: String
        $sortDirection: SortDirection
        $timezone: String
    ) {
        generateDspDeliveryCompletedDetailDownloadReport(
            filter: $filter
            sortBy: $sortBy
            sortDirection: $sortDirection
            timezone: $timezone
        )
    }
`;

export interface GenerateDspDeliveryCompletedDetailDownloadReportVariables {
    filter: DspDeliveryCompletedDetailFilterType;
    sortBy?: string | null;
    sortDirection?: 'ASC' | 'DESC' | null;
    timezone?: string | null;
}

export interface GenerateDspDeliveryCompletedDetailDownloadReportResponse {
    generateDspDeliveryCompletedDetailDownloadReport: string;
}
